import { Event } from "../../../api/events.models";
import { InventoryType } from "../../../api/inventory.models";
import { Reservation } from "../../../api/reservation.models";
import { isAccommodation } from "./inventory-data";
import { getInventoryItemsTotal } from "./reservation-functions";

export const getHSTPercent = () => {
	return 0.13;
}

export const getHSTAmount = (amount: number) => {
	return amount * getHSTPercent();
}


export const useAccommodationTax = (event: Event) => {
	if (!event) return false;
	return event.AccommodationTax !== null && event.AccommodationTax !== undefined;
}

export const getAccommodationTaxRate = (event: Event) => {
	if (!event) return 0;
	return (event.AccommodationTax || 0) / 100;
}

export const getAccommodationTaxAmount = (event: Event, reservation: Reservation, inventoryType: InventoryType[]) => {
	const accommodationInventory = inventoryType.filter(i => isAccommodation(i));
	var inventoryTotal = getInventoryItemsTotal(reservation, accommodationInventory);
	return inventoryTotal * getAccommodationTaxRate(event);
}